import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { createPortal } from 'react-dom';

const PaymentSuccessModal = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('checkout_status') === 'success') {
      const donationId = params.get('donation_id');
      if (donationId) {
        // Asynchronously notify backend of success without blocking the UI
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/checkout/validate`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ donationId })
        }).catch(err => console.error('Failed to validate donation token:', err));
      }

      setShow(true);
      
      // Clean up URL safely without refreshing the page
      params.delete('checkout_status');
      params.delete('status');
      params.delete('receipt_id');
      params.delete('payment_id');
      params.delete('state_id');
      params.delete('donation_id');
      
      const newSearch = params.toString() ? `?${params.toString()}` : '';
      navigate({ search: newSearch }, { replace: true });
    }
  }, [location, navigate]);

  if (!show) return null;

  return createPortal(
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-midnight/80 backdrop-blur-sm"
        onClick={() => setShow(false)}
      />

      {/* Modal Content */}
      <div className="relative z-[201] bg-charcoal border border-slate-dark/30 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col items-center p-8 text-center">
        {/* Success Icon */}
        <div className="w-20 h-20 bg-electric-yellow/20 rounded-full flex items-center justify-center mb-6">
          <svg className="w-10 h-10 text-electric-yellow" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h2 className="font-clash text-3xl font-bold text-warm-white mb-4">Uspješna uplata!</h2>
        
        <p className="text-soft-gray mb-8 text-lg">
          Hvala Vam puno na donaciji. Vaša podrška nam direktno pomaže da dovodimo sjajne goste i snimamo bolje epizode.
        </p>

        <button
          onClick={() => setShow(false)}
          className="w-full bg-electric-yellow text-midnight font-bold py-4 rounded-xl hover:bg-electric-yellow/90 transition-all text-lg"
        >
          Nazad na Unframed Talks
        </button>
      </div>
    </div>,
    document.body
  );
};

export default PaymentSuccessModal;
